import $ from 'jquery';
import {
  DataTableComponent,
  batchCheckControls,
} from 'web/components/CommonComponent';
import {useCallback, useState, useRef, useEffect} from 'react';
import enumList from 'web/utils/enumList';
import {fetchCustomerList} from 'web/redux/actions/CustomerActions';
import generateRandomID from 'web/utils/generateRandomID';

export const getDefaultCustomerItem = () =>
  JSON.parse(
    JSON.stringify({
      customerCode: '',
      customerName: '',
      address: '',
      contactName: '',
      contactPhone: '',
      faxId: '',
      memo: '',
    }),
  );

export const useCustomer = (
  dispatch,
  showMessage,
  onBatchHandle,
  baseComponent,
) => {
  const [customerList, setCustomerList] = useState([]);
  const tableRef = useRef(null);
  const getCustomerList = useCallback(
    (customerName = '', customerCode = '', contactName = '') => {
      if (!tableRef.current) prepareCustomerTable([]);
      tableRef.current.processing(true);

      const req = {
        customerName,
        customerCode,
        contactName,
      };

      dispatch(fetchCustomerList(req))
        .then((res) => {
          const statusCode = res.payload.code;
          if (statusCode && statusCode.isSuccessCode()) {
            setCustomerList(res.payload.result);
            const customerListRes = res.payload.result;
            prepareCustomerTable(customerListRes);
            tableRef.current.processing(false);
          } else {
            // showMessage('error', '', res);
          }
        })
        .catch((err) => {
          showMessage('error', err);
          console.error('fetchCaseList error', err);
        });
    },
  );

  const prepareCustomerTable = (customerList) => {
    // 定義資料內容
    const dataSet = customerList;

    // 定義欄位屬性
    const columnConfig = [
      {
        orderable: false,
        order: null,
        title:
          '<div class="form-check"><input class="form-check-input" type="checkbox" value="" id="check-all" data-show-indeterminate="true"/><label class="form-check-label" for="check-all"></label></div>',
        data: null,
        render: function (data, type, row, meta) {
          const checkboxId = 'cks-rolePerm-' + meta.row;
          return `
                <div class="form-check">
                    <input class="form-check-input item-cks-customer" type="checkbox" value="" id="${checkboxId}" name="cks" />
                    <label class="form-check-label" for="${checkboxId}"></label>
                </div>
            `;
        },
        width: '5%',
      },
      {
        title: '客戶代碼',
        className: 'dt-center',
        data: 'customerCode',
      },
      {title: '客戶簡稱', className: 'dt-center', data: 'customerShortName'},
      {title: '客戶名稱', className: 'dt-center', data: 'customerName'},
      {title: '客戶地址', className: 'dt-center', data: 'address'},
      {title: '聯絡人姓名', className: 'dt-center', data: 'contactName'},
      {title: '聯絡人電話', className: 'dt-center', data: 'contactPhone'},
      {title: '備註', className: 'dt-center', data: 'memo'},
      {title: '統編', className: 'dt-center', data: 'faxId'},
      {
        title: '啟用',
        className: 'dt-center',
        data: 'flgStatus',
        render: (data, type, row, meta) => {
          const enableId = 'eab-customer-' + meta.row;
          const isChecked = data === enumList.flgStatus.active ? 'checked' : '';
          const enableButton = baseComponent.checkPermission(
            enumList.moduleEnums.customer,
            enumList.accessModeEnums.delete,
          )
            ? ''
            : 'disabled';

          return `<div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch" id="${enableId}" ${isChecked} ${enableButton} />
                                <label class="form-check-label" for="${enableId}"></label>
                            </div>`;
        },
      },
      {
        orderable: false,
        order: null,
        data: null,
        className: 'dt-right',
        render: (data, type, row, meta) => {
          const editId = 'edit-customer-' + meta.row;
          const machineBindingID = 'machine-binding-' + generateRandomID();
          // let deleId = 'dele-customer-' + meta.row;
          const hasPermission = baseComponent.checkPermission(
            enumList.moduleEnums.customer,
            enumList.accessModeEnums.update,
          );
          const updateButton = hasPermission
            ? `<button type="button" class="btn btn-sm btn-link" id="${editId}">
                    <svg class="btn__icon btn__icon--sm me-1" aria-hidden="true">
                        <use href="#ico-edit"></use>
                    </svg>
                    修改
                </button>`
            : '';
          const machineAssignmentButton = hasPermission
            ? `
            <button
              class="btn btn-sm btn-link customer-machine-bindings"
              id="${machineBindingID}"
              data-row="${meta.row}"
            >
              機器綁定
            </button>
          `
            : '';
          // let deleteButton = baseComponent.checkPermission(enumList.moduleEnums.customer, enumList.accessModeEnums.delete)
          //   ? `<button type="button" class="btn btn-sm btn-link" id="${deleId}">
          //           刪除
          //       </button>`
          //   : '';
          return `
                <div class="btn-group" role="group" aria-label="">
                    ${updateButton}
                    ${machineAssignmentButton}
                </div>`;
        },
      },
    ];

    // 定義排序設定
    const orderConfig = {
      idx: 1,
      dir: 'asc',
    };

    // 定義固定欄位設定
    const fixedColumnsConfig = {
      start: 1,
    };

    // 先清除datatable
    if ($.fn.DataTable.isDataTable('#datatable__customerList')) {
      $('#datatable__customerList').DataTable().destroy();
    }

    // 重新繪製datatable
    tableRef.current = DataTableComponent(
      '#datatable__customerList',
      dataSet,
      columnConfig,
      orderConfig,
      fixedColumnsConfig,
      true,
      true,
    );
    // addEventListeners(customerList);
    batchCheckControls();
  };

  const onBatch = (alertMode = enumList.alertModalModeEnums.enable) => {
    const customerCodes = [];
    const checkboxes = document.querySelectorAll('.item-cks-customer');
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        const customerCode =
          customerList[parseInt(checkbox.id.split('-')[2])].customerCode;
        customerCodes.push(customerCode);
      }
    });
    // 如果沒有選擇任何資料就不處理
    if (customerCodes.length === 0) {
      return;
    }
    onBatchHandle(alertMode, '', customerCodes);
  };

  return {customerList, getCustomerList, onBatch};
};
